import { TableControls } from "src/components/Table";

import {
  IntegrationSort,
  IntegrationStatus,
  INTEGRATION_SORTS,
  INTEGRATION_STATUSES
} from "./constants";

export default function IntegrationListControls({
  onClickAdd,
  statusFilter,
  setStatusFilter,
  sort,
  setSort
}: {
  onClickAdd: () => void;
  statusFilter: IntegrationStatus;
  setStatusFilter: (newStatusFilter: IntegrationStatus) => void;
  sort: IntegrationSort;
  setSort: (newSort: IntegrationSort) => void;
}): JSX.Element {
  return (
    <TableControls
      addButtons={[{ label: "Add Integration", onClick: onClickAdd }]}
      filters={[
        {
          label: "Integration Status",
          value: statusFilter,
          onChange: (value: string) =>
            setStatusFilter(value as IntegrationStatus),
          options: INTEGRATION_STATUSES.map(status => ({
            value: status.key,
            label: status.label
          }))
        }
      ]}
      sort={{
        value: sort,
        onChange: value => setSort(value as IntegrationSort),
        options: INTEGRATION_SORTS.map(sort => ({
          value: sort.key,
          label: sort.label
        }))
      }}
    />
  );
}
